import { xingConnect } from '@xingternal/xing-frame-provider';

import selectors from './selectors';
import NavList from './NavList';

export default xingConnect(selectors)(NavList);
